import Swiper from '../../../node_modules/swiper'
import SwiperCore, { Navigation, Pagination } from '../../../node_modules/swiper/core';
SwiperCore.use([Navigation, Pagination]);

const TestimonialsSwiper = (() => {
    const DOM = {};
    const cacheDOM = () => {
    }

    const swiper = new Swiper(".swiper-container", {
        speed:1500,
        loop: true,
        lazy: {
            loadPrevNext: true
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        autoplay:
            {
                delay: 5000,
            }
    });

    const eventListener = () => {
        document.addEventListener("DOMContentLoaded", swiper)
    }

    const init = () => {
        cacheDOM();
        eventListener();
    };
    return {
        init,
    };
})();
export default TestimonialsSwiper;
